// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AdsenseController from "./adsense_controller"
application.register("adsense", AdsenseController)

import BarChartController from "./bar_chart_controller"
application.register("bar-chart", BarChartController)

import BurgerController from "./burger_controller"
application.register("burger", BurgerController)

import CarMakeYearsController from "./car_make_years_controller"
application.register("car-make-years", CarMakeYearsController)

import CascadingSelectController from "./cascading_select_controller"
application.register("cascading-select", CascadingSelectController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import ChatController from "./chat_controller"
application.register("chat", ChatController)

import CollapseAllController from "./collapse_all_controller"
application.register("collapse-all", CollapseAllController)

import CollapsibleFieldsetController from "./collapsible_fieldset_controller"
application.register("collapsible-fieldset", CollapsibleFieldsetController)

import CookieConsentController from "./cookie_consent_controller"
application.register("cookie-consent", CookieConsentController)

import CountriesModalController from "./countries_modal_controller"
application.register("countries-modal", CountriesModalController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import ElectricFuelFieldsController from "./electric_fuel_fields_controller"
application.register("electric-fuel-fields", ElectricFuelFieldsController)

import EngineSizeUnitController from "./engine_size_unit_controller"
application.register("engine-size-unit", EngineSizeUnitController)

import FlashMessageController from "./flash_message_controller"
application.register("flash-message", FlashMessageController)

import GalleryController from "./gallery_controller"
application.register("gallery", GalleryController)

import GalleryModalController from "./gallery_modal_controller"
application.register("gallery-modal", GalleryModalController)

import ImagePreviewController from "./image_preview_controller"
application.register("image-preview", ImagePreviewController)

import LineChartController from "./line_chart_controller"
application.register("line-chart", LineChartController)

import MessageFormController from "./message_form_controller"
application.register("message-form", MessageFormController)

import MessageSearchController from "./message_search_controller"
application.register("message-search", MessageSearchController)

import MileageUnitController from "./mileage_unit_controller"
application.register("mileage-unit", MileageUnitController)

import MobileFilterBtnController from "./mobile_filter_btn_controller"
application.register("mobile-filter-btn", MobileFilterBtnController)

import MultiSelectController from "./multi_select_controller"
application.register("multi-select", MultiSelectController)

import MultiStepFormController from "./multi_step_form_controller"
application.register("multi-step-form", MultiStepFormController)

import NewCarFieldsController from "./new_car_fields_controller"
application.register("new-car-fields", NewCarFieldsController)

import PasswordMatcherController from "./password_matcher_controller"
application.register("password-matcher", PasswordMatcherController)

import PieChartController from "./pie_chart_controller"
application.register("pie-chart", PieChartController)

import PriceFormatController from "./price_format_controller"
application.register("price-format", PriceFormatController)

import RangeSliderController from "./range_slider_controller"
application.register("range-slider", RangeSliderController)

import RangeValidateController from "./range_validate_controller"
application.register("range-validate", RangeValidateController)

import ShareController from "./share_controller"
application.register("share", ShareController)

import StickyBarController from "./sticky_bar_controller"
application.register("sticky-bar", StickyBarController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)

import CaptchaController from "./captcha_controller"
application.register("captcha", CaptchaController)

import TraderImageRemovalController from "./trader_image_removal_controller"
application.register("trader-image-removal", TraderImageRemovalController)

import AdminUsedCarsController from "./admin_used_cars_controller"
application.register("admin-used-cars", AdminUsedCarsController)

import UsernameCheckerController from "./username_checker_controller"
application.register("username-checker", UsernameCheckerController)

import PasswordVisibilityController from "./password_visibility_controller"
application.register("password-visibility", PasswordVisibilityController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import MakeAutocompleteController from "./make_autocomplete_controller"
application.register("make-autocomplete", MakeAutocompleteController)

import ConfirmInputController from "./confirm_input_controller"
application.register("confirm-input", ConfirmInputController)
